import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const AmerikaVizesiPage = () => {
  useEffect(() => {
    document.title = 'Amerika Vizesi | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Amerika B1/B2 turistik ve ticari vize başvuruları. ABD vizesi için profesyonel danışmanlık ve mülakat hazırlığı hizmeti.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/af3745b7707334fd5e976ccde5b8357c.jpg"
              alt="Amerika Vizesi"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              ABD Vizesi
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Amerika Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              B1/B2 turistik ve ticari vize başvurularında profesyonel destek ve mülakat hazırlığı
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Amerika B1/B2 Vizesi Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Amerika Birleşik Devletleri B1/B2 vizesi, turistik ve ticari amaçlı kısa süreli ziyaretler için düzenlenen vize türüdür. B1 vizesi iş amaçlı seyahatler için, B2 vizesi ise turizm, tatil, aile ziyareti ve tıbbi tedavi gibi amaçlar için kullanılır. Çoğu başvuruda bu iki vize türü birlikte (B1/B2) verilir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                ABD vizesi, diğer vize türlerinden farklı olarak konsolosluk mülakatı gerektiren bir süreçtir. Başvuru sahibinin profili, seyahat amacı ve Türkiye'ye geri dönüş bağları mülakat sırasında değerlendirilir. Bu nedenle doğru hazırlık ve profesyonel danışmanlık kritik önem taşır.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Amerika Vizesi Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">DS-160 Formu Doldurma</h3>
                      <p className="text-cream-200">Online başvuru formu eksiksiz ve doğru şekilde doldurulur. Form hatası vize reddine neden olabilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Vize Ücreti Ödeme</h3>
                      <p className="text-navy-700">Vize başvuru ücreti (185 USD) ödenir ve ödeme makbuzu saklanır.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-800 to-navy-700 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Mülakat Randevusu Alma</h3>
                      <p className="text-cream-200">Ankara veya İstanbul konsolosluğundan mülakat randevusu alınır.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-300 to-cream-200 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Mülakat Hazırlığı</h3>
                      <p className="text-navy-700">Sorulabilecek sorular için hazırlık yapılır, destekleyici belgeler düzenlenir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Konsolosluk Mülakatı</h3>
                      <p className="text-cream-200">Randevu gününde konsolosluğa gidilir ve mülakat yapılır. Sonuç genellikle mülakat sonunda bildirilir.</p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Gerekli Evraklar
              </h2>
              <div className="bg-cream-50 rounded-2xl p-6 md:p-8 mb-8 border-2 border-cream-200">
                <ul className="space-y-3 text-navy-700">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Pasaport:</strong> En az 6 ay geçerlilik süresi olan pasaport</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>DS-160 Onay Sayfası:</strong> Barkodlu onay sayfası çıktısı</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Fotoğraf:</strong> 5x5 cm beyaz fon üzerine renkli fotoğraf</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Randevu Onay Belgesi:</strong> Mülakat randevu belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Mali Durum Belgeleri:</strong> Banka hesap özeti, maaş bordrosu, vergi beyannamesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>İş Belgeleri:</strong> Çalışma belgesi, şirket evrakları, emekli maaş belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Seyahat Planı:</strong> Otel rezervasyonu, uçak bileti (opsiyonel)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Geri Dönüş Bağları:</strong> Tapu, araç ruhsatı, aile bağları belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Önceki Seyahat Belgeleri:</strong> Eski pasaportlar, önceki vizeler</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Mülakat Hazırlığı
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Amerika vizesi mülakatı, başvuru sürecinin en kritik aşamasıdır. Konsolosluk görevlisi, kısa bir görüşme ile başvuru sahibinin profilini değerlendirir. Profesyonel danışmanlık ile mülakat hazırlığı yapmak, başarı şansınızı önemli ölçüde artırır.
              </p>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-4">Sıkça Sorulan Sorular</h3>
                  <ul className="space-y-2 text-cream-200 text-sm">
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Amerika'ya neden gitmek istiyorsunuz?</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Ne iş yapıyorsunuz?</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Ne kadar süre kalacaksınız?</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Seyahat masraflarını nasıl karşılayacaksınız?</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Amerika'da tanıdığınız var mı?</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-question-line text-cream-400 mr-2 mt-1"></i>
                      <span>Daha önce yurt dışına çıktınız mı?</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-4">Mülakat İpuçları</h3>
                  <ul className="space-y-2 text-navy-700 text-sm">
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Sorulara kısa ve net cevaplar verin</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Göz teması kurun ve güvenli görünün</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Türkiye'ye geri dönüş nedenlerinizi vurgulayın</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Mali durumunuzu net şekilde açıklayın</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Gereksiz detaylara girmeyin</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-navy-900 mr-2 mt-1"></i>
                      <span>Destekleyici belgelerinizi hazır bulundurun</span>
                    </li>
                  </ul>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Vize Onay Kriterleri
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <p className="text-cream-200 text-base md:text-lg mb-6">
                  ABD konsoloslukları, vize başvurularını değerlendirirken aşağıdaki kriterlere özellikle dikkat eder:
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-cream-100/10 rounded-xl p-4">
                    <h4 className="font-bold text-cream-100 mb-2">Geri Dönüş Bağları</h4>
                    <p className="text-cream-300 text-sm">İş, aile, mülk gibi Türkiye'ye bağlayan güçlü nedenler</p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-4">
                    <h4 className="font-bold text-cream-100 mb-2">Mali Yeterlilik</h4>
                    <p className="text-cream-300 text-sm">Seyahat masraflarını karşılayabilecek düzenli gelir</p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-4">
                    <h4 className="font-bold text-cream-100 mb-2">Seyahat Geçmişi</h4>
                    <p className="text-cream-300 text-sm">Önceki yurt dışı seyahatleri ve vize uyumu</p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-4">
                    <h4 className="font-bold text-cream-100 mb-2">Seyahat Amacı</h4>
                    <p className="text-cream-300 text-sm">Net ve tutarlı seyahat planı</p>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel Danışmanlık Hizmetimiz
              </h2>
              <div className="grid md:grid-cols-3 gap-4 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-file-edit-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-navy-900 mb-2">DS-160 Form Desteği</h3>
                  <p className="text-navy-600 text-sm">Formunuzu hatasız şekilde doldurmada yardımcı oluyoruz</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-user-voice-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-navy-900 mb-2">Mülakat Koçluğu</h3>
                  <p className="text-navy-600 text-sm">Mülakat simülasyonu ve soru-cevap hazırlığı</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-folder-check-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-navy-900 mb-2">Evrak Kontrolü</h3>
                  <p className="text-navy-600 text-sm">Destekleyici belgelerin eksiksiz hazırlanması</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Amerika vizesi kaç yıl geçerlidir?</h3>
                  <p className="text-navy-600">Türk vatandaşları için genellikle 10 yıl geçerli çok girişli vize verilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Vize ücreti iade edilir mi?</h3>
                  <p className="text-navy-600">Hayır, vize reddedilse bile başvuru ücreti iade edilmez.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Vize reddedilirse ne yapmalıyım?</h3>
                  <p className="text-navy-600">Ret nedenini analiz ederek profilinizi güçlendirdikten sonra yeniden başvurabilirsiniz.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Mülakat İngilizce mi yapılır?</h3>
                  <p className="text-navy-600">Evet, ancak temel seviye İngilizce yeterlidir. Gerekirse tercüman desteği alınabilir.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              Amerika Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              Mülakat hazırlığı ve profesyonel danışmanlık için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default AmerikaVizesiPage;